<div [nbSpinner]="loading()"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">
  <app-match-board [currentUserTeamIds]="currentUserTeamIds" [matchesByWeek]="playedMatches" />
</div>
